import React, { useState } from "react";
import { ChevronRight, Search } from "lucide-react";
import { PROFESSIONS, PROFESSION_CATEGORIES } from "@/data/professions";

const SENIORITY = ["Júnior", "Pleno", "Sênior"];

export default function StepBriefing({ onNext }) {
  const [search, setSearch]       = useState("");
  const [selected, setSelected]   = useState("");
  const [seniority, setSeniority] = useState("Júnior");

  const q = search.toLowerCase().trim();

  // When searching: flat filtered list; otherwise: grouped by category
  const flatFiltered  = q ? PROFESSIONS.filter(p => p.name.toLowerCase().includes(q)) : null;
  const grouped       = PROFESSION_CATEGORIES.map(cat => ({
    category: cat,
    jobs: PROFESSIONS.filter(p => p.category === cat),
  }));

  const canProceed = !!selected;

  function select(name) {
    setSelected(name);
    setSearch("");
  }

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold"
          style={{ background: "#B0FCEA", color: "#00664C" }}>
          Etapa 1 de 3
        </div>
        <h2 className="text-2xl font-bold" style={{ fontFamily: "Poppins, sans-serif", color: "#003326" }}>
          Qual vaga você quer simular?
        </h2>
        <p className="text-sm" style={{ color: "#646C6F" }}>Selecione o cargo e a senioridade para começar.</p>
      </div>

      <div className="rounded-2xl p-6 bg-white space-y-5" style={{ border: "1px solid #E5E9EA" }}>
        {/* Busca de cargo */}
        <div>
          <label className="text-xs font-semibold mb-2 block" style={{ color: "#003326" }}>Cargo</label>

          <div className="relative mb-2">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4" style={{ color: "#99A6AB" }} />
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Buscar cargo..."
              className="w-full pl-9 pr-4 py-2.5 rounded-xl border text-sm"
              style={{ borderColor: "#E5E9EA" }}
            />
          </div>

          <div className="max-h-64 overflow-y-auto rounded-xl border p-2 space-y-1" style={{ borderColor: "#E5E9EA" }}>
            {flatFiltered ? (
              /* Search results — flat */
              flatFiltered.length > 0 ? flatFiltered.map(p => (
                <JobButton key={p.id} name={p.name} selected={selected} onSelect={select} />
              )) : (
                <p className="text-xs text-center py-3" style={{ color: "#99A6AB" }}>Nenhum cargo encontrado.</p>
              )
            ) : (
              /* No search — grouped */
              grouped.map(({ category, jobs }) => (
                <div key={category}>
                  <p className="text-xs font-bold px-2 pt-2 pb-1 uppercase tracking-wide"
                    style={{ color: "#99A6AB" }}>
                    {category}
                  </p>
                  {jobs.map(p => (
                    <JobButton key={p.id} name={p.name} selected={selected} onSelect={select} />
                  ))}
                </div>
              ))
            )}
          </div>

          {selected && (
            <div className="mt-2 flex items-center gap-2">
              <span className="text-xs font-semibold px-3 py-1 rounded-full"
                style={{ background: "#EAFAF6", color: "#00664C" }}>
                ✓ {selected}
              </span>
            </div>
          )}
        </div>

        {/* Senioridade */}
        <div>
          <label className="text-xs font-semibold mb-2 block" style={{ color: "#003326" }}>Senioridade</label>
          <div className="flex flex-wrap gap-2">
            {SENIORITY.map(s => (
              <button key={s} onClick={() => setSeniority(s)}
                className="px-4 py-2 rounded-full text-sm font-semibold transition-all"
                style={seniority === s
                  ? { background: "#00DCA4", color: "#003326" }
                  : { background: "#F2F4F4", color: "#646C6F" }}>
                {s}
              </button>
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={() => onNext({ job_title: selected, seniority })}
        disabled={!canProceed}
        className="w-full py-3.5 rounded-full text-sm font-bold flex items-center justify-center gap-2 transition-all"
        style={canProceed
          ? { background: "#00DCA4", color: "#003326" }
          : { background: "#E5E9EA", color: "#99A6AB" }}>
        Próximo: configurar entrevista <ChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
}

function JobButton({ name, selected, onSelect }) {
  const isSelected = selected === name;
  return (
    <button
      onClick={() => onSelect(name)}
      className="w-full text-left px-3 py-2 rounded-lg text-sm transition-all"
      style={isSelected
        ? { background: "#00DCA4", color: "#003326", fontWeight: 600 }
        : { color: "#2E3233" }}>
      {name}
    </button>
  );
}
